module.exports = __webpack_public_path__ + "stylesheets/company_441525232f616fe3caa4bfa45cfdca82.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/company.less
// module id = 6bdG
// module chunks = 153